import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SERVICES } from "./Home";

export default function Services() {
  return (
    <div className="bg-stone-950 py-24 lg:py-32" data-testid="services-page">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="label-eyebrow mb-3">All Services</div>
        <h1 className="font-display text-5xl sm:text-6xl font-black text-stone-50 tracking-tight max-w-3xl">
          Manual labor, plainly named.
        </h1>
        <p className="mt-5 text-stone-400 max-w-2xl leading-relaxed">
          Honest property maintenance and cleanup services across Eau Claire
          and surrounding communities. Here's the menu — pricing depends on
          the job, but we quote up front, every time.
        </p>

        <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {SERVICES.map((s) => (
            <div
              key={s.title}
              data-testid={`services-page-card-${s.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              className="border border-stone-800 bg-stone-900 p-8 flex flex-col hover:border-yellow-500/60 hover:-translate-y-1 transition-all"
            >
              <s.icon className="h-7 w-7 text-yellow-400 mb-4" />
              <h3 className="font-display text-2xl font-semibold text-stone-50">
                {s.title}
              </h3>
              <p className="mt-3 text-stone-400 text-sm leading-relaxed flex-1">
                {s.blurb}
              </p>
              <Link
                to={`/book?service=${encodeURIComponent(s.title)}`}
                data-testid={`services-page-card-cta-${s.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                className="mt-6 inline-flex items-center gap-1 text-yellow-400 text-xs uppercase tracking-[0.2em] font-bold hover:text-yellow-300"
              >
                Get a Quote <ArrowRight className="h-3 w-3" />
              </Link>
            </div>
          ))}
        </div>

        <div className="mt-20 border border-yellow-500/30 bg-stone-900 p-10">
          <h2 className="font-display text-3xl font-bold text-stone-50">
            Don't see your job?
          </h2>
          <p className="mt-3 text-stone-400 max-w-2xl">
            If it's property maintenance, cleanup, or general manual labor —
            there's a good chance we can help. Ask us.
          </p>
          <Link
            to="/book"
            data-testid="services-page-ask-btn"
            className="mt-6 inline-flex items-center gap-2 bg-yellow-500 text-yellow-950 font-bold uppercase tracking-wider px-6 py-3 border-2 border-yellow-500 hover:bg-yellow-400"
          >
            Ask About Your Job <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </div>
    </div>
  );
}
